import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M9.105 10.082a3.534 3.534 0 100-7.068 3.534 3.534 0 000 7.068zM11.56 20.159a2.89 2.89 0 011.812-4.923.322.322 0 00.27-.205.32.32 0 000-.334 5.95 5.95 0 00-3.856-2.018A6.106 6.106 0 003 18.758v.964a1.285 1.285 0 001.285 1.285h7.339a.334.334 0 00.373-.193.36.36 0 00-.078-.36l-.36-.295z",
      fill: "#333"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M15.532 21.006a.952.952 0 01-.681-.283l-1.928-1.928a.964.964 0 011.362-1.362l1.015 1.015a.32.32 0 00.463 0l3.586-3.586a.964.964 0 011.362 1.363l-4.498 4.498a.952.952 0 01-.681.283z",
      fill: "#333"
    }
  )
), t = l;
export {
  t as default
};
